import React, { useEffect, useState } from 'react';
import Header from './Header';
import './App.css';
import LoadingScreen from './LoadingScreen';
import DmmHeader from './Dmm';
// import FrontPage from './FrontPage';
import PageTwo from './PageTwo';
import PageThree from './PageThree';
import PageFour from './PageFour';
import PageFive from './PageFive';
import PageFive2 from './PageFive2';
import PageFive3 from './PageFive3';
import PageSix from './PageSix';
import { addDMMScripts ,getAttributionId,analytics_pageview} from './Helper';
// import FixedContainer from './FixedContainerIPA';

function App() {

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setTimeout(() =>{
      (document.getElementById("outPage") as any).style.display="";
      setLoading(false)
    }, 2000);
    setTimeout(() => addDMMScripts(), 5000);
    // addDMMScripts();
    analytics_pageview();
    analytics_pageview(window.location.pathname+':'+getAttributionId())
  }, []);


  return (
    <div className="App">
      <div className="header-container">
        <DmmHeader />
        <Header />
      </div>
      {loading === false ?
        <>
          {/* <FrontPage /> */}
          <PageTwo />
          <PageThree />
          <PageFour />
          <PageFive />
          <PageFive2 />
          <PageFive3 />
          <PageSix />
          {/* <div className="fixed-container">
            <FixedContainer />
          </div> */}

        </>
        : <LoadingScreen />
      }
      <div className="hidden">
        <input type="hidden" id="title_id" value="gyakuoudensetu" />
        <input type="hidden" id="is_general" value="0" />
        <label className="title_policy hidden"  ><a href="#" target="_blank">()</a></label>
        :<label className="dealer_name hidden"></label>
      </div>

    </div>
  );
}

export default App;
